var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({..._vm.backgroundColor, ..._vm.padding, ..._vm.shadow})},[_c('div',{staticClass:"video-item-4",class:_vm.container},[_vm._t("title"),_vm._t("subtitle"),_c('div',{staticClass:"video"},[_vm._t("video")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }